import Text from '@ilg-totallymoney/ui/components/Text'
import dynamic from 'next/dynamic'

const DynamicUnscoredFrequentlyAskedQuestions = dynamic(
    () => import('./UnscoredFrequentlyAskedQuestions'),
    {
        loading: () => <Text>Loading...</Text>,
    }
)

export default DynamicUnscoredFrequentlyAskedQuestions
